import Product from './pages/Product';

function App() {
  return (
    <Product />
  );
}

export default App;
